import React from 'react';
import WhitePaper from '@/components/elevation/WhitePaper/WhitePaper';
import { TitleFeatured } from '@/components/typography';
import OffersList from '@/features/oferta/components/OffersList/OffersList';
import LayoutInternal from '@/layout/LayoutInternal/LayoutInternal';

export interface OfertaIndexProps {
  data: OfferPageDataType;
}

const OfertaIndex = ({ data }: OfertaIndexProps) => {
  const { page, offers } = data;
  const breadcrumbs: BreadcrumbType = [{ text: page.title }];
  return (
    <LayoutInternal breadcrumbs={breadcrumbs} navbar="sticky">
      <WhitePaper col={12}>
        <TitleFeatured title={page.title} as="h1" />
        <OffersList offers={offers} />
      </WhitePaper>
    </LayoutInternal>
  );
};

export default OfertaIndex;
